import * as ActionTypes from "../Action/ActionTypes";
import * as SAGA from "./OrgAdminSaga";

import { takeLatest } from "redux-saga/effects";

export function* watchOrgAdmin() {
  yield takeLatest(ActionTypes.SET_ADMIN, SAGA.setAdminSaga);
  yield takeLatest(ActionTypes.GET_ORGS_OF_ADMIN, SAGA.getOrgsOfAdminSaga);
}